import WebsiteBehaviors from "../website-behaviors/index.js";

// This is sort of a special case of OJS because we need the PDF citation type for this specific site.
class JMSS extends WebsiteBehaviors {
	identifier() {
		return "JMSS";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return location.host === "jmss.org";
	}

	shouldFrameTakeControl() {
		return true;
	}
}

export default JMSS;
